export default "__VITE_ASSET__lbV6TVDM__"